import {
  createContext,
  useContext,
  useState,
} from "react";
import ConfirmDialog from "./ConfirmDialog";


export const ConfirmDialogContext = createContext(null);

export function ProvideConfirmDialog({ children }){
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogConfig, setDialogConfig] = useState(null);

  const openDialog = (config) => {
    setDialogOpen(true);
    setDialogConfig(config);
  };

  const resetDialog = () => {
    setDialogOpen(false);
    setDialogConfig(null);
  };

  const onConfirm = () => {
    resetDialog();
    dialogConfig?.actionCallback(true);
  };

  const onDismiss = () => {
    resetDialog();
    dialogConfig?.actionCallback(false);
  };

  return (
    <ConfirmDialogContext.Provider
      value={{ openDialog, resetDialog, onConfirm, onDismiss }}
    >
      <ConfirmDialog
        open={dialogOpen}
        title={dialogConfig?.title}
        message={dialogConfig?.message}
        onConfirm={onConfirm}
        onDismiss={onDismiss}
        onCloseWindow={onDismiss}
        confirmButton={dialogConfig?.confirmButton}
        dismissButton={dialogConfig?.dismissButton}
        closeWindow={dialogConfig?.closeWindow}
        confirmButtonContent={dialogConfig?.confirmButtonContent}
        dismissButtonContent={dialogConfig?.confirmButtonContent}
      />
      {children}
    </ConfirmDialogContext.Provider>
  );
}

export function useConfirmDialog() {
  const con = useContext(ConfirmDialogContext);
  
  const getConfirmation = (options) => {
    return new Promise((res) => {
      con?.openDialog({ actionCallback: res, ...options });
    });
  };

  return { getConfirmation };
}
